var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h1", [_vm._v("Ticketing Authorization")]),
    _vm._v(" "),
    _vm.isConfirmed
      ? _c("div", [
          _vm._v(
            '\n    Thank you for completing your ticketing authorization. If you’d like to go back to editing your event, click "My Events" on the navigation menu above, and then select your event.\n  '
          ),
        ])
      : _c("div", [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "mb-5" }, [
      _vm._v(
        "Whether you are hosting free and/or paid events, you must complete this SquadUP ticketing authorization to link your events on our website to SquadUP’s ticketing system. "
      ),
      _c("span", { staticClass: "font-sans-bold" }, [
        _vm._v("You will only need to do this once"),
      ]),
      _vm._v(", even if you are hosting more than one event."),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "mb-5" }, [
      _vm._v(
        "Follow the directions in the checkout form below. IMPORTANT: If "
      ),
      _c("span", { staticClass: "font-sans-bold" }, [_vm._v("any")]),
      _vm._v(
        " of the events you are hosting are paid events (even if some are free):"
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", { staticClass: "mb-5" }, [
      _c("li", [
        _vm._v(
          "As a security measure, you will be required to do a credit card authorization with a $1 charge (fully refunded in 24-48 hours)."
        ),
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "You also will be asked your payout method preference (PayPal, Venmo, or check) and details so that SquadUP can send you your ticketing revenue after the festival!"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }